(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ksi-product-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ksi-share-menu')) {
    customElements.define('ksi-share-menu', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        const menu = this.querySelector('[data-share-menu]');
        const trigger = menu.querySelector('summary');
        const copy = this.querySelector('[data-copy]');
        const input = this.querySelector('[data-link]');
        const status = this.querySelector('[data-status]');
        const appleDevice = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        if (appleDevice) this.querySelector('[data-sms]').href = 'sms:&body=' + encodeURIComponent(this.dataset.message);
        const close = () => {
          menu.open = false;
          copy.open = false;
          status.textContent = '';
        };
        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) close();
        }, options);
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && menu.open) {
            event.preventDefault();
            close();
            trigger.focus();
          }
        }, options);
        this.addEventListener('focusout', (event) => {
          if (event.relatedTarget && !this.contains(event.relatedTarget)) close();
        }, options);
        input.addEventListener('focus', () => input.select(), options);
        copy.querySelector('summary').addEventListener('click', async (event) => {
          event.preventDefault();
          try {
            if (!navigator.clipboard || !window.isSecureContext) throw new Error('Clipboard unavailable');
            await navigator.clipboard.writeText(this.dataset.url);
            copy.open = false;
            status.textContent = this.dataset.copied;
          } catch {
            copy.open = true;
            status.textContent = this.dataset.manual;
            input.focus();
            input.select();
          }
        }, options);
      }
      disconnectedCallback() { this.abortController?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
